import xss from "xss";

import Price from "./price.js";

class MetalItem {
  constructor(props) {
    let {
      kennziffer,
      id,
      name,
      text,
      image,
      imageList,
      price,
      mwst,
      kind,
      make,
      amount,
      margin,
      popularity,
      innenProvision,
      konditionenProzent,
      rchargeKz,
      diffsteuerungKz,
      preissteuerungKz,
      locked,
      produktInfo,
    } = props || {};
    this.kennziffer = xss(kennziffer);
    this.id = xss(id);
    this.name = xss(name);
    this.text = xss(text);
    this.image = xss(image);
    imageList = Array.isArray(imageList) ? imageList : [];
    this.imageList = imageList.map((i) => xss(i)).filter((i) => !!i);
    if (!this.imageList.includes(this.image))
      this.imageList.unshift(this.image);
    this.margin = Number(margin) || 0;
    this.price = Number(price) || 0;
    this.mwst = Math.round((Number(mwst) || 0) * 100) / 100;
    this.kind = xss(kind);
    this.make = xss(make);
    this.amount = Number(amount) || 0;
    this.itemprice = Price.create(this.price);
    this.tax =
      this.mwst > 0
        ? this.itemprice.clone().multiply(this.mwst / 100)
        : Price.create(0);
    this.taxSum = null;
    this.dirty = false;
    this.positionMwst = Price.create(0);
    this.positionDues = Price.create(0);
    this.positionSum = Price.create(0);
    this.updatePrices();
    this.popularity = !popularity 
      ? 99999
      : popularity;
    this.innenProvision = Number(innenProvision) || 0;
    this.konditionenProzent = Number(konditionenProzent) || 0;
    this.rchargeKz = !!xss(rchargeKz).match(/^(true|J)$/i);
    this.diffsteuerungKz = !!xss(diffsteuerungKz).match(/^(true|J)$/i);
    this.preissteuerungKz = !!xss(preissteuerungKz).match(/^(true|J)$/i);
    this.locked = !!locked;
    this.produktInfo = xss(produktInfo);
  }
  static create({
    kennziffer,
    id,
    name,
    text,
    image,
    imageList,
    price,
    mwst,
    kind,
    make,
    amount,
    margin,
    popularity,
    innenProvision,
    konditionenProzent,
    rchargeKz,
    diffsteuerungKz,
    preissteuerungKz,
    produktInfo,
  }) {
    return new MetalItem({
      kennziffer,
      id,
      name,
      text,
      image,
      imageList,
      price,
      mwst,
      kind,
      make,
      amount,
      margin,
      popularity,
      innenProvision,
      konditionenProzent,
      rchargeKz,
      diffsteuerungKz,
      preissteuerungKz,
      produktInfo,
    });
  }
  getLinkId() {
    return String(this.id).substring(2) + "?mandant=" + localStorage.getItem("mandantIdLink");
  }
  setPositionDues(num) {
    this.positionDues = Price.create(num);
  }
  setPositionMwst(num) {
    this.positionMwst = Price.create(num);
  }
  addItem(metal) {
    this.amount = this.amount + metal.amount;
    this.updatePrices();
  }
  addAmount(num) {
    this.amount += Number(num) || 0;
    this.updatePrices();
  }
  resetAmount() {
    this.amount = 1;
    this.updatePrices();
  }
  incrementAmount() {
    // we are directly routed in the cart and have to respect a locked basket
    if (this.isLocked()) {
      return;
    }
    this.amount = Number(this.amount);
    this.amount += 1;
    this.updatePrices();
  }
  changeAmount(amount) {
    if (amount < 0 || this.isLocked() || !amount > 1) return;
    this.amount = Number(amount);
    this.updatePrices();
  }
  decrementAmount() {
    // we are directly routed in the cart and have to respect a locked basket
    if (this.amount < 2 || this.isLocked()) return;
    this.amount = Number(this.amount);
    this.amount -= 1;
    this.updatePrices();
  }
  updatePrices() {
    this.netto = this.itemprice.clone();
    this.brutto = this.itemprice.clone().add(this.tax);
    if (this.amount > 0) {
      this.netto.multiply(this.amount);
      this.brutto =
        this.mwst > 0
          ? this.netto.clone().multiply((this.mwst + 100) / 100)
          : this.netto.clone();
    }
    this.taxSum = null;
  }
  // used in basket for recreation after commit
  recreate({ amount, price, netto, brutto, mwst, dirty }) {
    this.amount = amount;
    this.price = price;
    this.mwst = Math.round(mwst * 100) / 100;
    this.itemprice.setPrice(price);
    this.netto.setPrice(netto);
    this.brutto.setPrice(brutto);
    this.tax =
      this.mwst > 0
        ? this.itemprice.clone().multiply(this.mwst / 100)
        : Price.create(0);
    this.dirty = dirty;
  }
  isLocked() {
    return this.locked;
  }
  toJSONForCart() {
    return {
      kennziffer: this.kennziffer,
      anzahl: this.amount,
      preis: this.itemprice.getPrice(),
      netto: this.netto.getPrice(),
      brutto: this.positionSum.getPrice(),
      gebuehren: this.positionDues.getPrice(),
      mwstBetrag: this.netto
        .clone()
        .add(this.positionDues)
        .multiply(this.mwst / 100)
        .getPrice(),
      mwstProzent: this.mwst,
    };
  }
  toJSONForOrderRequest() {
    return {
      kennziffer: this.kennziffer,
      anzahl: this.amount,
      preis: this.itemprice.getPrice(),
      netto: this.netto.getPrice(),
      brutto: this.positionSum.getPrice(),
      mwstBetrag: this.netto
        .clone()
        .add(this.positionDues)
        .multiply(this.mwst / 100)
        .getPrice(),
      mwstProzent: this.mwst,
    };
  }
  toJSONForOrder() {
    return {
      kennziffer: this.kennziffer,
      anzahl: this.amount,
      preis: this.itemprice.getPrice(),
      netto: this.netto.getPrice(),
      brutto: this.positionSum.getPrice(),
      id: this.id,
      name: this.name,
      text: this.text,
      image: this.image,
      imageList: this.imageList,
      mwstBetrag: this.netto
        .clone()
        .add(this.positionDues)
        .multiply(this.mwst / 100)
        .getPrice(),
      mwstProzent: this.mwst,
      produktInfo: this.produktInfo,
    };
  }
  clone() {
    return MetalItem.create(this);
  }
}

export default MetalItem;
